import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05589cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-input-wrapper" }
const _hoisted_2 = ["name", "value", "placeholder", "disabled"]
const _hoisted_3 = { class: "error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Field, {
      name: _ctx.name,
      "model-value": _ctx.modelValue
    }, {
      default: _withCtx(({ field, errors, errorMessage }) => [
        _createElementVNode("input", {
          name: _ctx.name,
          class: _normalizeClass(["number-input", { invalid: errorMessage }]),
          value: _ctx.replaceValue(field.value),
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          placeholder: _ctx.disabled ? '' : _ctx.placeholder,
          disabled: _ctx.disabled
        }, null, 42, _hoisted_2),
        _createElementVNode("span", _hoisted_3, _toDisplayString(errors[0]), 1)
      ]),
      _: 1
    }, 8, ["name", "model-value"])
  ]))
}